export default function getCookieDomain(baseUrl) {
  try {
    const url = new URL(baseUrl)
    let hostname = url.hostname.replace(/^www\./, '')

    if (hostname === 'localhost' || hostname === '0.0.0.0' || hostname === '127.0.0.1') {
      return 'localhost'
    }

    return `.${hostname}`
  } catch (e) {
    return 'localhost'
  }
}
